// extracted by mini-css-extract-plugin
export default {"input":"Input_input__4Qjlp","label":"Input_label__OzOlQ","disabled":"Input_disabled__eWHBx"};